import { toast, ToastContainer } from "react-toastify";

export function AlertNotification() {
  return (
    <ToastContainer
      position={toast.POSITION.BOTTOM_RIGHT}
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
  );
}
